import axiosInstance from './axios-instance';

export const fetchPerspectiveGroups = async ({ page = 1, limit = 20, category } = {}) => {
  const params = { page, limit };
  if (category) params.category = category;
  return axiosInstance.get('/api/v1/publisher/perspectives/groups', { params });
};

export const fetchPerspectiveGroup = async (slug) => {
  return axiosInstance.get(`/api/v1/publisher/perspectives/groups/${slug}`);
};

export const fetchPerspectiveGroupResponses = async (slug, { page = 1, limit = 10 } = {}) => {
  return axiosInstance.get(`/api/v1/publisher/perspectives/groups/${slug}/responses`, {
    params: { page, limit }
  });
};
